import request from '@/utils/request'

export function getTutorMessageList (key, page, size) {
  return request({
    url: '/api/Message/GetTutorMessageList?key=' + key + '&page=' + page + '&size=' + size + '&type=1',
    method: 'Post'
  })
}
export function getTutorWarningMessageList (type, key, page, size) {
  return request({
    url: '/api/Message/GetTutorMsgMessageList?key=' + key + '&page=' + page + '&size=' + size + '&type=' + type,
    method: 'Post'
  })
}
export function getTutorNoticeMessageList (type, key, page, size) {
  return request({
    url: '/api/Message/GetTutorMsgMessageList?key=' + key + '&page=' + page + '&size=' + size + '&type=' + type,
    method: 'Post'
  })
}
export function getTutorLevelMessageList (type, key, page, size) {
  return request({
    url: '/api/Message/getTutorLevelMessageList?key=' + key + '&page=' + page + '&size=' + size + '&type=' + type,
    method: 'Post'
  })
}
export function getMessageById (id) {
  return request({
    url: '/api/Message/GetMessageById?id=' + id,
    method: 'Post'
  })
}
export function getremindMessageById (id) {
  return request({
    url: '/api/Message/GetMessageRemindById?id=' + id,
    method: 'Post'
  })
}
export function deleteMessage (values) {
  return request({
    url: '/api/Message/DeleteMessage',
    data: { values },
    method: 'Post'
  })
}
export function deleteRemindMessage (values) {
  return request({
    url: '/api/Message/DeleteRemindMessage',
    data: { values },
    method: 'Post'
  })
}
export function NotReadMsgCount () {
  return request({
    url: '/api/Message/NotReadMsgCount',
    method: 'Post'
  })
}
// moodle
export function getMoodleMessagePHP (tuid,limit,offset,start,end) {
  return request({
    url: '/moodle/lib/ajax/service.php',
    method: 'Post',
    data:[{"index":0,"methodname":"message_popup_get_popup_notifications_tutorapi","args":{"tuid":tuid,"start":start,"end":end,"limit":limit,"offset":offset}}]
  })
}
// moodle
export function getMoodleMessage () {
  return request({
    url: `/api/message/GetTutorMoodleMsg`,
    method: 'Post',
  })
}
// 
export function getTutorMoodleMsgList (limit,offset,start,end) {
  return request({
    url: '/api/Message/GetTutorMoodleMsgList',
    method: 'Post',
    data:{
      start,
      end,
      limit,
      offset
    }
  })
}

// 滴滴打老师 显示弹框埋点
export function addTeacheDidiPoint (values) {
  return request({
    url: '/api/Message/AddTeacheDidiPoint',
    data: values,
    method: 'Post'
  })
}
// 已读调用
export function readTeacheDidiMessage (values) {
  return request({
    url: '/api/Message/readTeacheDidiMessage',
    data: values,
    method: 'Post'
  })
}
